import React from "react";
import { IntlContextConsumer } from "gatsby-plugin-intl";
import { Link as GatsbyLink } from "gatsby";

const HardLink = ({ to, language, children, ...rest }) => (
  <IntlContextConsumer>
    {(intl) => {
      const languageLink = language || intl.language;
      const link = intl.routed || language ? `/${languageLink}${to}` : `${to}`;

      const handleClick = (e) => {
        e.preventDefault();
        window.location.href = link;
      };
      return (
        <GatsbyLink {...rest} to={link} onClick={handleClick}>
          {children}
        </GatsbyLink>
      );
    }}
  </IntlContextConsumer>
);

export default HardLink;
